import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { LEGAL } from "./legalInfo";

export function Section({ n, title, children }) {
    return (
        <section className="mt-8">
            <h2 className="text-white font-display font-bold text-lg sm:text-xl mb-3">
                {n != null && <span className="text-brand">{n}. </span>}
                {title}
            </h2>
            <div className="space-y-3 text-gray-300">{children}</div>
        </section>
    );
}

export function Highlight({ children }) {
    return (
        <div className="rounded-2xl border border-brand/30 bg-brand/10 p-4 sm:p-5 text-gray-200">
            {children}
        </div>
    );
}

export default function LegalLayout({ title, intro, children }) {
    useEffect(() => {
        document.title = `${title} | Monoticket`;
    }, [title]);

    return (
        <div className="bg-[#0f0e17] min-h-screen text-gray-300">
            <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
                <span className="text-brand font-mono font-semibold text-xs uppercase tracking-widest">
                    Monoticket
                </span>
                <h1 className="text-3xl sm:text-4xl font-display font-bold text-white mt-2 mb-2 leading-tight">
                    {title}
                </h1>
                <p className="text-gray-500 text-sm mb-8">
                    Última actualización: {LEGAL.actualizacion}
                </p>

                {intro}

                <div className="text-sm sm:text-[15px] leading-relaxed">{children}</div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
                    <Link to="/" className="text-brand hover:underline">← Volver al inicio</Link>
                    <Link to="/terminos" className="text-gray-400 hover:text-white">Términos y Condiciones</Link>
                    <Link to="/privacidad" className="text-gray-400 hover:text-white">Aviso de Privacidad</Link>
                </div>
            </div>
        </div>
    );
}
